import React from "react";
import {useDispatch} from "react-redux";
import {Avatar, Popover} from "antd";
import Replace from '../../util/Extensions/ReplaceExtension';
import { UserOutlined } from '@ant-design/icons';
import {userSignOut} from "../../appRedux/actions/Auth";
import axios from 'util/Api'
import config from "../../util/ApiforContext"

const userId = localStorage.getItem("userId");

const UserProfile = () => {
  const userSignOut = (value) => {
    axios.get(`${config.apiUrl}/Auth/Logout?userId=${value?.replace('"','').replace('"','').toString()}`,config.headers)
    .then(res => {
      if(res.data.success==true){
        localStorage.removeItem("token");
        window.location.reload()
      }
      }
    );
  };
  const dispatch = useDispatch();
  const userMenuOptions = (
    <ul className="gx-user-popover">
      <li><a style={{color:'black'}} href="/password-change">Şifremi Değiştir</a></li>
      <li onClick={() => userSignOut(userId)}>Çıkış Yap
      </li>
    </ul>
  );
  return (

    <div className="gx-flex-row gx-align-items-center gx-mb-4 gx-avatar-row">
      <Popover placement="bottomRight" content={userMenuOptions} trigger="click">
        <Avatar style={{backgroundColor: '#002447'}}
      icon={<UserOutlined  />}/>
        <span className="gx-avatar-name" style={{color:"#ffffff", marginLeft:"10px", fontSize:"96%"}}>{Replace(localStorage.getItem("userName"))}<i
          className="icon icon-chevron-down gx-fs-xxs gx-ml-2"/></span>
      </Popover>
    </div>

  )
};

export default UserProfile;
